import * as React from "react";

const chevronRightNew: React.FC = () => {
    return (
        <svg viewBox="0 0 6 11" xmlns="http://www.w3.org/2000/svg">
            <path d="m6 5-5 5-.7-.7L4.6 5 .3.7 1 0z" fill="#333F48" fillRule="evenodd"/>
        </svg>

    );
};


export default React.memo(chevronRightNew);
